/* eslint-disable */

export function removeHtml(str) {
    let regex = /(<([^>]+)>)/ig;
    return str.replace(regex, "");
}